export const InvoiceStatus = {
    OPEN:        0,
    SENT:        1,
    PAID:        2,
    OVERDUE:     4,
    WRITTEN_OFF: 5,
    DELETED:     6,
} as const;

export type InvoiceStatusValue = typeof InvoiceStatus[keyof typeof InvoiceStatus];

export const DunningLevel = {
    NONE:      0,
    FRIENDLY:  1,
    DEMANDING: 2,
    FINAL:     3,
    LEGAL:     4,
} as const;

export type DunningLevelValue = typeof DunningLevel[keyof typeof DunningLevel];

export const DUNNING_OVERDUE_THRESHOLD = DunningLevel.FINAL;
